import { useState, useCallback } from "react";
import { getTutorial } from "Services/tutorial_service";

/**
 * Hook personalizado para manejar la carga de datos manualmente.
 * No realiza el fetch automáticamente al instanciarse.
 *
 * @returns {Object} Estado y funciones del hook
 * @returns {Array} data - Datos obtenidos del servicio.
 * @returns {boolean} isLoading - `true` si está cargando datos.
 * @returns {any} error - Contiene el error si ocurre uno.
 * @returns {Function} fetchData - Función para iniciar manualmente la carga de datos.
 */
export const useTutorial = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);


  const fetchData = useCallback(async () => {
    setError(null);
    setIsLoading(true);
    try {
      const result = await getTutorial();
      setData(result);
    } catch (err) {
      setError(err);
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    data,
    isLoading,
    error,
    fetchData,
  };
};
